<template>
	<div class="input-unit">
		<span>{{ before }}</span>
		<el-input
			ref="input"
			id="input"
			:value="selfData"
			:placeholder="placeholder"
			validate-event
			v-bind="$attrs"
			@change="change"
			@input="input"
		></el-input>
		<span>{{ after }}</span>
	</div>
</template>

<script>
import formStore from '@/mixins/formStore.js';
export default {
	mixins: [formStore],
	props: {
		scope: {
			type: Object,
		},
		before: {
			type: String,
		},
		after: {
			type: String,
		},
		placeholder: {
			type: String,
		},
	},
	methods: {
		change(val) {
			this.selfData = val;
			!this.delay && this.setVal();
			this.$emit('change', val);
			this.scope && this.scope.change && this.scope.change(val);
		},
		input(val) {
			this.selfData = val;
		},
	},
};
</script>

<style lang="scss" scoped>
.input-unit {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  span {
    white-space: nowrap;
    padding: 0 5px;
  }
}
</style>
